import { FC } from 'react';
import { bigNumberToText } from '../../../../../components/utils';

export type TrendItemProps = {
    isFirst: boolean;
    loading: boolean;
    title: string;
    total: number;
};

export const TrendItem: FC<TrendItemProps> = ({ isFirst, loading, title, total }) => {
    return (
        <div
            className={`p-4 rounded-lg w-36 flex flex-col gap-2 border border-sf-gray-100 ${
                isFirst ? 'bg-sf-gray-50' : ''
            }`}>
            {loading ? (
                <div className="animate-pulse">
                    <div className={`h-6 w-full rounded ${isFirst ? 'bg-sf-gray-100' : ''}`}></div>
                </div>
            ) : (
                <span className="font-sf-poppins text-[21px] font-bold leading-6">{bigNumberToText(total)}</span>
            )}

            <span className="text-[12px] font-medium">{title}</span>
        </div>
    );
};
